import type { MidRelatedRecommendGoods } from 'shared/src/api';
import type { GoodsData } from '@banhala/ui-kit';
import { convertRenderDataToGoodsData } from 'shared/src/utils/convertRenderDataToGoodsData';

export const convertMidRelatedRecommendGoodsItemToGoodsData = (
  input: MidRelatedRecommendGoods,
): GoodsData & MidRelatedRecommendGoods => {
  return {
    ...input,
    ...convertRenderDataToGoodsData(input),
  };
};
